var map = {
	"./A1-1-Bylub-cod83-B.png": 136,
	"./A1-1-Bylub-cod83.png": 137,
	"./A1-10-Zenthos-cod92.png": 138,
	"./A1-11-Kal-Belzeruk-cod93.png": 139,
	"./A1-12-Vorggon-cod94.png": 140,
	"./A1-13-Zyntaris-cod95.png": 141,
	"./A1-14-Zytrion-X-cod96.png": 142,
	"./A1-15-Abdução-cod97.png": 143,
	"./A1-16-Kalberus-cod98.png": 144,
	"./A1-17-Kal-Belzeruk-Ev-cod99.png": 145,
	"./A1-17-Kal-Belzeruk-cod99.png": 146,
	"./A1-18-Lupzen-cod116.png": 147,
	"./A1-19-Nubb-cod117.png": 148,
	"./A1-2-Droypper-cod84.png": 149,
	"./A1-20-Qhizol-cod118.png": 150,
	"./A1-21-Uzen-cod119-B.png": 151,
	"./A1-21-Uzen-cod119.png": 152,
	"./A1-22-Quazen-cod120.png": 153,
	"./A1-23-Dyplozen-cod121.png": 154,
	"./A1-24-Groxxyn-cod122.png": 155,
	"./A1-25-Granoid-Trix-cod123.png": 156,
	"./A1-26-Upgrade-das-Naves-cod124.png": 157,
	"./A1-27-Groxxyn-Ev-cod125.png": 158,
	"./A1-27-Groxxyn-cod125.png": 159,
	"./A1-28-Ahni_Grav-cod136.png": 160,
	"./A1-29-Devorax-cod137.png": 161,
	"./A1-3-Syderia-cod85.png": 162,
	"./A1-30-Krolgzer-cod138.png": 163,
	"./A1-31-Tetrak-cod139.png": 164,
	"./A1-32-Deskderb-cod140-B.png": 165,
	"./A1-32-Deskderb-cod140.png": 166,
	"./A1-33-Symbio-Trix-cod141.png": 167,
	"./A1-34-Retaliação-Feroz-cod142.png": 168,
	"./A1-35-Luzzen-cod143-B.png": 169,
	"./A1-35-Luzzen-cod143.png": 170,
	"./A1-36-Oblithul-cod144.png": 171,
	"./A1-37-Disparos-Coordenados-cod145.png": 172,
	"./A1-4-Strylik-cod86.png": 173,
	"./A1-5-Dextrion-cod87.png": 174,
	"./A1-6-Glyndor-cod88.png": 175,
	"./A1-7-Nergus-cod89.png": 176,
	"./A1-8-Clonnos-cod90.png": 177,
	"./A1-9-Neonyus-cod91.png": 178,
	"./A1-F1-Zyberion Nexus-codF3.png": 179,
	"./A1-R1-Recurso-codR3.png": 180,
	"./G1-1-Themis-Althea-cod21.png": 181,
	"./G1-10-Alana Dimitris-cod30-B.png": 182,
	"./G1-10-Alana-Dimitris-cod30.png": 183,
	"./G1-11-Cloey-Harris-cod31.png": 184,
	"./G1-12-Lorena-Pallas-cod32.png": 185,
	"./G1-13-Sapphira-Andreas-cod33.png": 186,
	"./G1-14-Sonya-Kamber-cod34.png": 187,
	"./G1-15-Alisha-Kamber-cod35.png": 188,
	"./G1-16-Pyetra-Vlachos-cod36.png": 189,
	"./G1-17-Armas-Secretas-da-Ilha-de-Náxos-cod37.png": 190,
	"./G1-18-União-das-Arqueiras-cod38.png": 191,
	"./G1-19-Amazonas-Calouras-cod39.png": 192,
	"./G1-2-Alice-Saitta-cod22.png": 193,
	"./G1-20-Lorena-Pallas-cod40.png": 194,
	"./G1-21-Kalya-Linard-cod52.png": 195,
	"./G1-22-Nohely-Kaligaris-cod53.png": 196,
	"./G1-23-Yrís-Hatzis-cod54-B.png": 197,
	"./G1-23-Yrís-Hatzis-cod54.png": 198,
	"./G1-24-Jacee-Loris-cod55.png": 199,
	"./G1-25-Tessa-Rubis-cod56.png": 200,
	"./G1-26-Kynthia-Cali-cod57.png": 201,
	"./G1-27-Maya-Myron-cod58.png": 202,
	"./G1-28-Katherine-Adamopoulos-cod59.png": 203,
	"./G1-29-Thea-Persayious-cod60.png": 204,
	"./G1-3-Alessa-Chronis-cod23.png": 205,
	"./G1-30-Ataque-Inesperado-da-Arqueira-cod61.png": 206,
	"./G1-31-Maya-Myron-cod62.png": 207,
	"./G1-32-Norah-Kallis-cod67.png": 208,
	"./G1-33-Aurora Roussou-cod68-B.png": 209,
	"./G1-33-Aurora Roussou-cod68.png": 210,
	"./G1-34-Machado da Aurora-cod69.png": 211,
	"./G1-35-Katherine Adamopoulos-cod70.png": 212,
	"./G1-36-Chuva-de-Flechas-cod72.png": 213,
	"./G1-37-Hillare-Philemon-cod78.png": 214,
	"./G1-38-Esconderijo-das-Amazonas-cod79.png": 215,
	"./G1-39-Ataque-Simultâneo-das-Amazonas-cod80.png": 216,
	"./G1-4-Heleen-Herod-cod24.png": 217,
	"./G1-40-Tamesis-Acalântis-cod81-B.png": 218,
	"./G1-40-Tamesis-Acalântis-cod81.png": 219,
	"./G1-41-Hillare-Philemon-Ev-cod82.png": 220,
	"./G1-5-Julie-Asker-cod25.png": 221,
	"./G1-6-Emilly-Makris-cod26.png": 222,
	"./G1-7-Agatha-Petrides-cod27.png": 223,
	"./G1-8-Alexxia-Liakos-cod28.png": 224,
	"./G1-9-Nyssa-Kontos-cod29.png": 225,
	"./G1-F1-Palácio-das-Amazonas-codF2.png": 226,
	"./G1-R1-Recurso-codR2.png": 227,
	"./M1-1-Koloryun-cod100.png": 228,
	"./M1-10-Téfferos-Vallac-cod109.png": 229,
	"./M1-11-Temerius-Ragnor-cod110.png": 230,
	"./M1-12-Yazorath-cod111.png": 231,
	"./M1-13-Grimório-Arcano-cod112.png": 232,
	"./M1-14-Santuário-dos-Monólitos-Rúnicos-cod113.png": 233,
	"./M1-15-Espelhamento-Arcano-cod114.png": 234,
	"./M1-16-Yazaroth-cod115-B.png": 235,
	"./M1-16-Yazaroth-cod115.png": 236,
	"./M1-16-Yazorath-Ev-cod115.png": 237,
	"./M1-17-Furtóvi-cod126.png": 238,
	"./M1-18-Ariela-Baji-cod127-B.png": 239,
	"./M1-18-Ariela-Baji-cod127.png": 240,
	"./M1-19-Öthuren Djelko-cod128.png": 241,
	"./M1-19-Öthuren-Djelko-cod128.png": 242,
	"./M1-2-Laydon-cod101.png": 243,
	"./M1-20-Avanya-Neev-cod129.png": 244,
	"./M1-21-Halfdan-Galadris-cod130.png": 245,
	"./M1-22-Uldrak_Zul-cod131.png": 246,
	"./M1-23-Ertus-Árvore-da-Cura-cod132.png": 247,
	"./M1-24-Congelar-cod133.png": 248,
	"./M1-25-Ertus-Desgarrada-cod134.png": 249,
	"./M1-26-Halfdan-Galadris-Ev-cod135.png": 250,
	"./M1-26-Halfdan-Galadris-cod135.png": 251,
	"./M1-27-Unicorjik-cod146.png": 252,
	"./M1-28-Nector-Sadjin-cod147.png": 253,
	"./M1-29-Ravyna-cod148.png": 254,
	"./M1-3-Gabyno-Ogam-cod102.png": 255,
	"./M1-30-Worgnulf-cod149-B.png": 256,
	"./M1-30-Worgnulf-cod149.png": 257,
	"./M1-31-Nixxa-Naybul-cod150.png": 258,
	"./M1-32-Feitiço-Dracônico-cod151.png": 259,
	"./M1-33-Fúria-do-Dragão-cod152.png": 260,
	"./M1-34-Wyn-Arsalis-cod153-B.png": 261,
	"./M1-34-Wyn-Arsalis-cod153.png": 262,
	"./M1-35-Dragmunn-cod154.png": 263,
	"./M1-36-Tempestade-Arcana-cod155.png": 264,
	"./M1-4-Nayromi-Naybul-cod103.png": 265,
	"./M1-5-Nubro-Ody-cod104.png": 266,
	"./M1-6-Jawari-Felasu-cod105.png": 267,
	"./M1-7-Zurkana-cod106.png": 268,
	"./M1-8-Braduk-cod107.png": 269,
	"./M1-9-Zakan-O-Gladiador-cod108.png": 270,
	"./M1-F1-Templo-da-Magia-Arcana-codF4.png": 271,
	"./M1-R1-Recurso-codR4.png": 272,
	"./S1-1-Phrozb-cod1.png": 273,
	"./S1-10-Qytherk-cod10.png": 274,
	"./S1-11-Jyrgozz-cod11.png": 275,
	"./S1-12-Zorbozz-cod12.png": 276,
	"./S1-13-Zibrolttar-cod13.png": 277,
	"./S1-14-Zardok-cod14.png": 278,
	"./S1-15-Cretaur-K-cod15.png": 279,
	"./S1-16-Noctrobazz-cod16.png": 280,
	"./S1-17-Kromyn-B-cod17.png": 281,
	"./S1-18-Zartropoolz-cod18.png": 282,
	"./S1-19-Zagockranozz-cod19.png": 283,
	"./S1-2-Zagoc-cod2.png": 284,
	"./S1-20-Cretaur-K-cod20.png": 285,
	"./S1-21-Brox-cod41.png": 286,
	"./S1-22-Orbtralzz-cod42.png": 287,
	"./S1-23-Malbai-cod43.png": 288,
	"./S1-24-Therkoj-cod44.png": 289,
	"./S1-25-Nergyzzak-cod45.png": 290,
	"./S1-26-Kytrov-cod46.png": 291,
	"./S1-27-Crottanox-cod47.png": 292,
	"./S1-28-Phroniac-cod48-B.png": 293,
	"./S1-28-Phroniac-cod48.png": 294,
	"./S1-29-Zartrox-cod49.png": 295,
	"./S1-3-Katarb-cod3.png": 296,
	"./S1-30-Fúria-Robótica-cod50.png": 297,
	"./S1-31-Zardok-cod51.png": 298,
	"./S1-32-Wormyd-cod63.png": 299,
	"./S1-33-Zartroworb-cod64.png": 300,
	"./S1-34-Trowerbell-cod65.png": 301,
	"./S1-35-Phroniac-Ev-cod66-B.png": 302,
	"./S1-35-Phroniac-cod66.png": 303,
	"./S1-36-Explosão Goldroniana-cod71.png": 304,
	"./S1-37-Gowba-cod73.png": 305,
	"./S1-38-Morgev-cod74.png": 306,
	"./S1-39-Rajada-de-Energia-cod75.png": 307,
	"./S1-4-Dogorb-cod4.png": 308,
	"./S1-40-Reyzar-cod76-B.png": 309,
	"./S1-40-Reyzar-cod76.png": 310,
	"./S1-41-Nergyzzak-Ev-cod77.png": 311,
	"./S1-5-Jorb-cod5.png": 312,
	"./S1-6-Bauzz-cod6.png": 313,
	"./S1-7-Beltrozz-cod7.png": 314,
	"./S1-8-Garjix-cod8-B.png": 315,
	"./S1-8-Garjix-cod8.png": 316,
	"./S1-9-Nazzbrok-cod9.png": 317,
	"./S1-F1-Zartrower-codF1.png": 318,
	"./S1-R1-Recurso-codR1.png": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;